import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import Reveal from "../Reveal";

const CORRIDORS = [
  { from: "United States", to: "Nigeria", fromC: "USD", toC: "NGN" },
  { from: "United Kingdom", to: "Kenya", fromC: "GBP", toC: "KES" },
  { from: "UAE", to: "Ghana", fromC: "AED", toC: "GHS" },
];

const rateFmt = (n) => n.toLocaleString("en-US", { minimumFractionDigits: n >= 100 ? 2 : 4, maximumFractionDigits: n >= 100 ? 2 : 4 });

const CorridorRow = () => {
  const [rates, setRates] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    (async () => {
      try {
        const res = await fetch("https://open.er-api.com/v6/latest/USD", { signal: controller.signal, headers: { Accept: "application/json" } });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        if (json?.result !== "success" || !json?.rates) throw new Error("Unexpected response");
        setRates(json.rates);
      } catch {
        setRates(null);
      }
    })();
    return () => controller.abort();
  }, []);

  return (
    <div className="mt-12" data-testid="corridor-row">
      <Reveal>
        <p className="text-center text-xs font-semibold uppercase tracking-[0.18em] text-[#2E7CD6]">Popular Corridors</p>
      </Reveal>
      <div className="mt-6 grid gap-4 sm:grid-cols-3">
        {CORRIDORS.map((c, i) => (
          <Reveal key={c.to} delay={i * 0.08}>
            <div
              data-testid={`corridor-${c.fromC.toLowerCase()}-${c.toC.toLowerCase()}`}
              className="rounded-2xl border border-[#E2E8F0] bg-white p-5 shadow-sm transition-[transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:shadow-md"
            >
              <div className="flex items-center justify-between gap-2">
                <p className="text-sm font-semibold text-[#0F172A]">{c.from}</p>
                <ArrowRight size={15} strokeWidth={2} className="shrink-0 text-[#2E7CD6]" />
                <p className="text-sm font-semibold text-[#0F172A]">{c.to}</p>
              </div>
              <p className="mt-3 font-heading text-lg font-bold text-[#1E3A6E]">
                1 {c.fromC} = {rates ? rateFmt(rates[c.toC] / rates[c.fromC]) : "…"} {c.toC}
              </p>
              <p className="mt-1 text-xs text-[#94A3B8]">Live reference rate</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
};

export default CorridorRow;
